import { memo, useCallback } from "react";
import { Grid, Input } from "semantic-ui-react";
import CircularButton from "../../../../../../components/shared/circularbutton/CircularButton";
import useSubnetsList from "../hooks/useSubnetsList";
import { HandleInputChange } from "../../../../../../custom-hooks/form/types";
import { useNetworkFormContext } from "../../context/NetworkFormContext";

type SubnetNameProps = {
  onChange: HandleInputChange;
  index: number;
  subnetsCount: number;
  name: string;
};

const SubnetName = ({
  onChange,
  index,
  subnetsCount,
  name,
}: SubnetNameProps) => {
  const { onDeleteSubnet } = useSubnetsList();

  const onDelete = useCallback(() => {
    onDeleteSubnet(index);
  }, [index, onDeleteSubnet]);

  const { formData } = useNetworkFormContext();

  return (
    <>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <h5>Subnet Name {subnetsCount > 1 && `(#${index + 1})`}</h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <Input
          placeholder={`${formData.name ? formData.name + "-" : ""}subnet-${index + 1}`}
          value={name}
          className="select-box full"
          name="name"
          onChange={onChange}
        />
        {index > 0 && (
          <CircularButton
            className="button button--circular margin-left-half button--circular__danger"
            onClick={onDelete}
            icon="trash"
            popupContent="Delete this worker"
          />
        )}
      </Grid.Column>
    </>
  );
};

export default memo(SubnetName);
